import React, { useCallback, useState } from 'react';
import { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import { openDialog } from '../../../../../../../../../app/dialog/dialog.actions';
import { deleteBoardList } from '../../../../../../../../../app/page/page-storage/meeting-boards/meeting-boards.actions';
import { boardListSelectors } from '../../../../../../../../../app/resource/boards/boardList/boardList.selectors';
import { IBoardList } from '../../../../../../../../../app/resource/boards/boardList/boardList.types';
import { useSelect, useSelectWithParams } from '../../../../../../../../../utils/selector.utils';
import { IBoardListHeaderProps } from './types';
import { isMemberPartOfMeeting } from '../../../../../../../../../utils/user.utils';
import { authSelectors } from '../../../../../../../../../app/auth/auth.selectors';
import { userSelectors } from '../../../../../../../../../app/resource/user/user.selectors';
import { IMeetingSimple } from '../../../../../../../../../app/resource/meeting-simple/meeting-simple.types';
import { meetingSimpleSelectors } from '../../../../../../../../../app/resource/meeting-simple/meeting-simple.selectors';
import { CirclePlusButton } from '../../../../../../CirclePlusButton';

export const BoardListHeader: FunctionComponent<IBoardListHeaderProps> = ({ boardListId, meetingId }) => {
  const loggedUserId = useSelect(authSelectors.selectLoggedUser);
  const loggedUser = useSelectWithParams(userSelectors.selectResourceById, loggedUserId ?? '');

  const meeting = (useSelectWithParams(
    meetingSimpleSelectors.selectResourceById,
    meetingId,
  ) as unknown) as IMeetingSimple;

  const [isActive, setActive] = useState(false);
  const boardList = useSelectWithParams(boardListSelectors.selectResourceById, boardListId) as IBoardList;
  const boardListData = { id: boardList.id, name: boardList.name, boardId: boardList.boardId };
  const toggleClass = () => {
    setActive(!isActive);
  };

  const dispatch = useDispatch();

  const onDeleteBoardList = useCallback(() => {
    dispatch(deleteBoardList(boardListId));
  }, [boardListId, dispatch]);
  const openEditBoardListFormDialog = useCallback(() => {
    dispatch(openDialog('boardListFormDialog', { boardListData, boardId: boardList.boardId }));
  }, [boardList.boardId, boardListData, dispatch]);

  const openTrelloCardFormDialog = useCallback(() => {
    dispatch(openDialog('trelloReplacementFormDialog', { boardListId, meetingId }));
  }, [boardListId, dispatch, meetingId]);

  const isMeetingMember = loggedUser && meeting && isMemberPartOfMeeting(loggedUser, meeting);

  return (
    <div className="panel-header p-0">
      <h2 className="bold">{boardList.name}</h2>
      <div className="ml-auto flex">
        {isMeetingMember && (
          <span className="mr-05 btn-badge theme-color pointer popup_button" onClick={openTrelloCardFormDialog}>
            <CirclePlusButton title="Add Card" size={22} onClick={openTrelloCardFormDialog} />
          </span>
        )}
        <div className={isActive ? 'dropdown ml-auto ln opened' : 'dropdown ml-auto ln'} onClick={toggleClass}>
          <span className="dropdown-button lightGray-bg" data-action="submenu">
            <i className="icon-dot-3 link blueGray" />
          </span>
          <ul className="dropdown-menu drop-right">
            <li onClick={openEditBoardListFormDialog}>
              <span className="drop-item">Edit List</span>
            </li>
            <li onClick={onDeleteBoardList}>
              <span className="drop-item">Delete List</span>
            </li>
            <li onClick={openTrelloCardFormDialog}>
              <span className="drop-item">Add Card</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
